import React from "react";

export const FileIcon = ({
  type,
  width,
  height,
}: {
  type: string;
  width?: string;
  height?: string;
}) => {
  switch (type) {
    case "application/pdf":
      return <PdfIcon width={width || "27"} height={height || "32"} />;
      break;
    case "image/png":
      return <PngIcon width={width || "27"} height={height || "32"} />;
    case "image/jpg":
      return <JpgIcon width={width || "27"} height={height || "32"} />;
    case "image/jpeg":
      return <JpgIcon width={width || "27"} height={height || "32"} />;
    case "text/csv":
      return <CsvIcon width={width || "27"} height={height || "32"} />;
    case "application/zip":
      return <ZipIcon width={width || "27"} height={height || "32"} />;
    // xlsx file
    case "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
      return <XlsIcon width={width || "27"} height={height || "32"} />;
    // docx file
    case "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
      return <DocsIcon width={width || "27"} height={height || "32"} />;
    // pptx file
    case "application/vnd.openxmlformats-officedocument.presentationml.presentation":
      return <PptxIcon width={width || "27"} height={height || "32"} />;
    default:
      return <DatIcon width={width || "27"} height={height || "32"} />;

      break;
  }
};

const JpgIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path
      d="M15.125 8.5625H8.875C8.35723 8.5625 7.9375 8.98223 7.9375 9.5V14.5C7.9375 15.0178 8.35723 15.4375 8.875 15.4375H15.125C15.6428 15.4375 16.0625 15.0178 16.0625 14.5V9.5C16.0625 8.98223 15.6428 8.5625 15.125 8.5625Z"
      stroke="#907BFF"
      stroke-linejoin="round"
    />
    <path
      d="M13.5625 11.0625C13.9077 11.0625 14.1875 10.7827 14.1875 10.4375C14.1875 10.0923 13.9077 9.8125 13.5625 9.8125C13.2173 9.8125 12.9375 10.0923 12.9375 10.4375C12.9375 10.7827 13.2173 11.0625 13.5625 11.0625Z"
      stroke="#907BFF"
      stroke-miterlimit="10"
    />
    <path
      d="M12.9375 13.5598L11.1668 11.7924C11.0541 11.6797 10.9027 11.6144 10.7434 11.6096C10.5842 11.6049 10.4291 11.6612 10.31 11.767L7.9375 13.8764"
      stroke="#907BFF"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.375 15.4389L13.784 13.0299C13.8942 12.9195 14.0416 12.8543 14.1974 12.847C14.3532 12.8398 14.5061 12.8911 14.626 12.9908L16.0625 14.1889"
      stroke="#907BFF"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const ZipIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path d="M11.694 8.69604H13.3899V7.00012H11.694V8.69604Z" fill="#767B85" />
    <path
      d="M10.0006 10.3894H11.6966V8.69347H10.0006V10.3894Z"
      fill="#767B85"
    />
    <path d="M11.694 12.0828H13.3899V10.3868H11.694V12.0828Z" fill="#767B85" />
    <path
      d="M10.0006 13.7781H11.6966V12.0821H10.0006V13.7781Z"
      fill="#767B85"
    />
    <path
      d="M11.6938 17.16C11.2454 17.1593 10.8156 16.9808 10.4987 16.6636C10.1817 16.3464 10.0036 15.9164 10.0032 15.468V13.7761H13.3857V15.468C13.3854 15.9167 13.207 16.3468 12.8898 16.664C12.5726 16.9813 12.1424 17.1596 11.6938 17.16V17.16ZM10.8685 14.6414V15.468C10.8685 15.6871 10.9554 15.8971 11.1101 16.0521C11.2649 16.2071 11.4748 16.2943 11.6938 16.2947C11.9129 16.2943 12.123 16.2071 12.2779 16.0522C12.4329 15.8972 12.5201 15.6872 12.5204 15.468V14.6414H10.8685Z"
      fill="#767B85"
    />
  </svg>
);

const PdfIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <g clip-path="url(#clip0_1731_1214)">
      <path
        d="M16.3066 13.1449C15.6343 12.426 13.7986 12.7189 13.359 12.7722C12.7127 12.1331 12.2732 11.3609 12.118 11.0946C12.3507 10.3757 12.5058 9.65673 12.5317 8.8846C12.5317 8.21889 12.2732 7.5 11.5492 7.5C11.2907 7.5 11.0579 7.65971 10.9286 7.87273C10.6184 8.43196 10.7476 9.55031 11.2389 10.6953C10.9545 11.5207 10.6959 12.3195 9.97199 13.7308C9.2222 14.0502 7.64501 14.7959 7.51572 15.5947C7.46403 15.8343 7.54157 16.074 7.72255 16.2604C7.90354 16.4201 8.13622 16.5 8.36896 16.5C9.32559 16.5 10.2564 15.1421 10.9028 13.997C11.4457 13.8107 12.299 13.5443 13.1522 13.3846C14.1605 14.2899 15.0396 14.423 15.505 14.423C16.1255 14.423 16.3583 14.1568 16.4358 13.9171C16.5651 13.6509 16.4875 13.358 16.3066 13.1449ZM15.6601 13.5976C15.6343 13.784 15.4017 13.9704 14.9879 13.8639C14.4967 13.7308 14.0571 13.4911 13.6693 13.1716C14.0055 13.1183 14.7552 13.0384 15.2982 13.1449C15.505 13.1982 15.7119 13.3313 15.6601 13.5976ZM11.3423 8.11236C11.394 8.0325 11.4716 7.97926 11.5492 7.97926C11.7819 7.97926 11.8336 8.27213 11.8336 8.51182C11.8077 9.07105 11.7043 9.63017 11.5233 10.1627C11.1355 9.09761 11.2131 8.35199 11.3423 8.11236ZM11.2907 13.2781C11.4975 12.8521 11.7819 12.1064 11.8853 11.7869C12.118 12.1862 12.5058 12.6656 12.7127 12.8786C12.7127 12.9053 11.9112 13.065 11.2907 13.2781ZM9.76516 14.3432C9.17051 15.355 8.54995 15.9941 8.21382 15.9941C8.16213 15.9941 8.11038 15.9674 8.05868 15.9408C7.98108 15.8875 7.95524 15.8077 7.98108 15.7012C8.05868 15.3284 8.73093 14.8225 9.76516 14.3432Z"
        fill="#EF4C54"
      />
    </g>
    <defs>
      <clipPath id="clip0_1731_1214">
        <rect width="10" height="10" fill="white" transform="translate(7 7)" />
      </clipPath>
    </defs>
  </svg>
);

const CsvIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 26 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g opacity="0.3">
      <path
        d="M18.1582 6.5666C17.4474 6.5659 16.766 6.276 16.2634 5.76055C15.7608 5.24511 15.4781 4.54622 15.4774 3.81728V0H3.49851C2.57065 0 1.68079 0.378027 1.02469 1.0509C0.368595 1.72377 0 2.63637 0 3.58795V25.2171C0.00137787 26.1677 0.370577 27.079 1.02653 27.7507C1.68247 28.4224 2.57155 28.7997 3.49851 28.7997H17.8787C18.8057 28.7997 19.6947 28.4224 20.3507 27.7507C21.0066 27.079 21.3758 26.1677 21.3772 25.2171V6.5666H18.1582Z"
        fill="#0075C8"
      />
    </g>
    <path
      d="M21.3773 6.5666H18.1583C17.4475 6.5659 16.7661 6.276 16.2635 5.76055C15.7609 5.24511 15.4782 4.54622 15.4775 3.81728V0L21.3773 6.5666Z"
      fill="#0075C8"
    />
    <path
      d="M23.9134 22.7466H7.65726C6.50413 22.7466 5.56934 23.7053 5.56934 24.8879V29.8585C5.56934 31.0411 6.50413 31.9998 7.65726 31.9998H23.9134C25.0666 31.9998 26.0014 31.0411 26.0014 29.8585V24.8879C26.0014 23.7053 25.0666 22.7466 23.9134 22.7466Z"
      fill="#0075C8"
    />
    <path d="M12 29V30H11V29H12Z" fill="white" />
    <path
      d="M16.2495 29.31C16.0375 29.566 15.7875 29.762 15.4995 29.898C15.2115 30.03 14.8895 30.096 14.5335 30.096C14.2135 30.096 13.9155 30.038 13.6395 29.922C13.3675 29.806 13.1315 29.648 12.9315 29.448C12.7315 29.248 12.5735 29.012 12.4575 28.74C12.3415 28.464 12.2835 28.168 12.2835 27.852C12.2835 27.536 12.3415 27.242 12.4575 26.97C12.5735 26.694 12.7315 26.456 12.9315 26.256C13.1315 26.056 13.3675 25.898 13.6395 25.782C13.9155 25.666 14.2135 25.608 14.5335 25.608C14.8775 25.608 15.1795 25.668 15.4395 25.788C15.7035 25.908 15.9375 26.082 16.1415 26.31L15.5715 26.862C15.4435 26.714 15.2955 26.596 15.1275 26.508C14.9635 26.42 14.7675 26.376 14.5395 26.376C14.3395 26.376 14.1515 26.412 13.9755 26.484C13.7995 26.552 13.6455 26.65 13.5135 26.778C13.3855 26.906 13.2835 27.062 13.2075 27.246C13.1315 27.426 13.0935 27.628 13.0935 27.852C13.0935 28.076 13.1315 28.28 13.2075 28.464C13.2835 28.644 13.3855 28.798 13.5135 28.926C13.6455 29.054 13.7995 29.154 13.9755 29.226C14.1515 29.294 14.3395 29.328 14.5395 29.328C14.7795 29.328 14.9915 29.28 15.1755 29.184C15.3635 29.084 15.5295 28.944 15.6735 28.764L16.2495 29.31ZM18.2138 30.096C18.0298 30.096 17.8538 30.07 17.6858 30.018C17.5178 29.966 17.3638 29.888 17.2238 29.784C17.0838 29.68 16.9618 29.554 16.8578 29.406C16.7538 29.254 16.6718 29.078 16.6118 28.878L17.3738 28.578C17.4298 28.794 17.5278 28.974 17.6678 29.118C17.8078 29.258 17.9918 29.328 18.2198 29.328C18.3038 29.328 18.3838 29.318 18.4598 29.298C18.5398 29.274 18.6098 29.242 18.6698 29.202C18.7338 29.158 18.7838 29.104 18.8198 29.04C18.8558 28.976 18.8738 28.902 18.8738 28.818C18.8738 28.738 18.8598 28.666 18.8318 28.602C18.8038 28.538 18.7558 28.478 18.6878 28.422C18.6238 28.366 18.5378 28.312 18.4298 28.26C18.3258 28.208 18.1958 28.154 18.0398 28.098L17.7758 28.002C17.6598 27.962 17.5418 27.908 17.4218 27.84C17.3058 27.772 17.1998 27.69 17.1038 27.594C17.0078 27.498 16.9278 27.386 16.8638 27.258C16.8038 27.126 16.7738 26.978 16.7738 26.814C16.7738 26.646 16.8058 26.49 16.8698 26.346C16.9378 26.198 17.0318 26.07 17.1518 25.962C17.2758 25.85 17.4218 25.764 17.5898 25.704C17.7618 25.64 17.9518 25.608 18.1598 25.608C18.3758 25.608 18.5618 25.638 18.7178 25.698C18.8778 25.754 19.0118 25.828 19.1198 25.92C19.2318 26.008 19.3218 26.106 19.3898 26.214C19.4578 26.322 19.5078 26.424 19.5398 26.52L18.8258 26.82C18.7858 26.7 18.7118 26.592 18.6038 26.496C18.4998 26.4 18.3558 26.352 18.1718 26.352C17.9958 26.352 17.8498 26.394 17.7338 26.478C17.6178 26.558 17.5598 26.664 17.5598 26.796C17.5598 26.924 17.6158 27.034 17.7278 27.126C17.8398 27.214 18.0178 27.3 18.2618 27.384L18.5318 27.474C18.7038 27.534 18.8598 27.604 18.9998 27.684C19.1438 27.76 19.2658 27.852 19.3658 27.96C19.4698 28.068 19.5478 28.192 19.5998 28.332C19.6558 28.468 19.6838 28.626 19.6838 28.806C19.6838 29.03 19.6378 29.224 19.5458 29.388C19.4578 29.548 19.3438 29.68 19.2038 29.784C19.0638 29.888 18.9058 29.966 18.7298 30.018C18.5538 30.07 18.3818 30.096 18.2138 30.096ZM19.9324 25.704H20.8084L21.6964 28.29L21.8524 28.842H21.9004L22.0684 28.29L22.9924 25.704H23.8684L22.3024 30H21.4504L19.9324 25.704Z"
      fill="white"
    />
    <path
      d="M16.8371 15.9644H4.44994C4.33082 15.9644 4.21655 15.9171 4.13221 15.833C4.04786 15.7489 4.00032 15.6347 4 15.5156C4 15.3963 4.0474 15.2818 4.13178 15.1974C4.21616 15.1131 4.33061 15.0657 4.44994 15.0657H16.8371C16.8961 15.0657 16.9546 15.0773 17.0091 15.0999C17.0636 15.1226 17.1132 15.1557 17.1548 15.1975C17.1965 15.2393 17.2296 15.2889 17.252 15.3435C17.2745 15.3981 17.286 15.4566 17.2858 15.5156C17.2858 15.6346 17.2386 15.7488 17.1544 15.8329C17.0703 15.9171 16.9561 15.9644 16.8371 15.9644Z"
      fill="#0075C8"
    />
    <path
      d="M11.9514 13.4297H4.44994C4.33082 13.4297 4.21655 13.3825 4.13221 13.2983C4.04786 13.2142 4.00032 13.1001 4 12.9809C4 12.8616 4.0474 12.7472 4.13178 12.6628C4.21616 12.5784 4.33061 12.531 4.44994 12.531H11.9514C12.0705 12.5313 12.1846 12.5789 12.2687 12.6632C12.3529 12.7476 12.4001 12.8618 12.4001 12.9809C12.3998 13.0999 12.3524 13.2138 12.2683 13.2979C12.1842 13.382 12.0703 13.4294 11.9514 13.4297Z"
      fill="#0075C8"
    />
    <path
      d="M11.9514 10.8987H4.44994C4.33082 10.8987 4.21655 10.8514 4.13221 10.7673C4.04786 10.6832 4.00032 10.5691 4 10.4499C4 10.3306 4.0474 10.2161 4.13178 10.1318C4.21616 10.0474 4.33061 10 4.44994 10H11.9514C12.0705 10.0003 12.1846 10.0479 12.2687 10.1322C12.3529 10.2165 12.4001 10.3308 12.4001 10.4499C12.3998 10.5689 12.3524 10.6828 12.2683 10.7669C12.1842 10.851 12.0703 10.8984 11.9514 10.8987Z"
      fill="#0075C8"
    />
    <path
      d="M16.617 10H14.4957C14.1259 10 13.8262 10.2998 13.8262 10.6695V12.7908C13.8262 13.1606 14.1259 13.4603 14.4957 13.4603H16.617C16.9868 13.4603 17.2865 13.1606 17.2865 12.7908V10.6695C17.2865 10.2998 16.9868 10 16.617 10Z"
      fill="#0075C8"
    />
  </svg>
);

const DatIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.97799 15.3418C9.68858 15.3418 9.39916 15.3418 9.10975 15.3418C8.98949 15.3418 8.88927 15.25 8.8749 15.1263L8.81639 14.6259C8.59487 14.5407 8.39096 14.4177 8.21231 14.2643L7.76393 14.4624C7.65329 14.5113 7.52642 14.4674 7.46618 14.3596C7.32147 14.1001 7.17676 13.8406 7.03205 13.5812C6.97192 13.4734 6.99869 13.3376 7.09485 13.2629L7.48448 12.96C7.44567 12.7214 7.44567 12.4763 7.48448 12.2378L7.09485 11.9349C6.99857 11.8602 6.97181 11.7244 7.03205 11.6166C7.17676 11.3572 7.32147 11.0977 7.46618 10.8382C7.52631 10.7304 7.65317 10.6865 7.76393 10.7355L8.21231 10.9335C8.39108 10.7802 8.59487 10.6571 8.81639 10.5719L8.8749 10.0715C8.88939 9.94783 8.98949 9.85596 9.10975 9.85596C9.39916 9.85596 9.68858 9.85596 9.97799 9.85596C10.0983 9.85596 10.1985 9.94783 10.2128 10.0715L10.2713 10.5719C10.4929 10.6571 10.6968 10.7801 10.8754 10.9335L11.3238 10.7355C11.4345 10.6865 11.5614 10.7304 11.6216 10.8382C11.7663 11.0977 11.911 11.3572 12.0557 11.6166C12.1158 11.7244 12.0891 11.8602 11.9929 11.9349L11.6033 12.2378C11.6421 12.4764 11.6421 12.7215 11.6033 12.96L11.9929 13.2629C12.0892 13.3376 12.1159 13.4734 12.0557 13.5812C11.911 13.8406 11.7663 14.1001 11.6216 14.3596C11.5614 14.4674 11.4346 14.5113 11.3238 14.4624L10.8754 14.2643C10.6967 14.4176 10.4929 14.5407 10.2713 14.6259L10.2128 15.1263C10.1985 15.2501 10.0984 15.3418 9.97799 15.3418ZM9.54387 11.361C8.88348 11.361 8.34809 11.9153 8.34809 12.5989C8.34809 13.2825 8.88348 13.8368 9.54387 13.8368C10.2043 13.8368 10.7397 13.2825 10.7397 12.5989C10.7397 11.9153 10.2043 11.361 9.54387 11.361ZM14.5355 16.9929C14.3017 16.928 14.0679 16.8631 13.8341 16.7984C13.7369 16.7714 13.6753 16.6747 13.6894 16.5717L13.7469 16.1543C13.5857 16.0358 13.4468 15.8907 13.3344 15.7268L12.9309 15.7863C12.8312 15.801 12.7379 15.7372 12.7119 15.6365C12.6492 15.3945 12.5867 15.1525 12.524 14.9104C12.4979 14.8098 12.548 14.7062 12.6414 14.6673L13.0195 14.51C13.0381 14.3085 13.0894 14.1106 13.1706 13.9265L12.9191 13.5945C12.857 13.5126 12.8637 13.397 12.9348 13.3232C13.106 13.1461 13.2772 12.9688 13.4483 12.7916C13.5195 12.718 13.6311 12.711 13.7104 12.7753L14.0312 13.0357C14.2077 12.9519 14.398 12.8983 14.5949 12.879L14.7467 12.4878C14.7843 12.3912 14.8844 12.3394 14.9816 12.3663C15.2154 12.4312 15.4492 12.496 15.683 12.5609C15.7802 12.5879 15.8418 12.6845 15.8277 12.7876L15.7702 13.2049C15.9314 13.3234 16.0703 13.4686 16.1827 13.6324L16.5862 13.5729C16.6859 13.5583 16.7793 13.6221 16.8052 13.7227C16.8679 13.9647 16.9304 14.2068 16.9931 14.4488C17.0192 14.5494 16.9691 14.6531 16.8758 14.6919L16.4976 14.8493C16.4791 15.0508 16.4277 15.2487 16.3465 15.4328L16.5979 15.7647C16.66 15.8467 16.6533 15.9623 16.5822 16.0359C16.4111 16.2131 16.2398 16.3903 16.0687 16.5675C15.9976 16.6411 15.8859 16.6481 15.8066 16.5838L15.4858 16.3234C15.3094 16.4072 15.119 16.4609 14.9222 16.4802L14.7703 16.8713C14.7328 16.9681 14.6327 17.0199 14.5355 16.9929ZM15.0173 13.6796C14.4837 13.5316 13.9354 13.8594 13.7924 14.4117C13.6494 14.964 13.9661 15.5317 14.4996 15.6797C15.0331 15.8277 15.5815 15.4999 15.7245 14.9476C15.8674 14.3953 15.5508 13.8277 15.0173 13.6796ZM13.7997 11.6337C13.8969 11.6606 13.997 11.6088 14.0346 11.5122L14.1865 11.121C14.3833 11.1019 14.5736 11.0481 14.7501 10.9643L15.0709 11.2247C15.15 11.289 15.2617 11.282 15.333 11.2084C15.5041 11.0312 15.6754 10.8539 15.8465 10.6768C15.9176 10.6032 15.9243 10.4875 15.8622 10.4055L15.6107 10.0735C15.6919 9.88942 15.7431 9.69153 15.7618 9.49003L16.1399 9.33268C16.2333 9.29382 16.2834 9.19019 16.2573 9.08957C16.1946 8.84753 16.132 8.6055 16.0694 8.36347C16.0433 8.26285 15.9499 8.19904 15.8504 8.21367L15.4469 8.27316C15.3345 8.10921 15.1956 7.9642 15.0344 7.84571L15.0919 7.42833C15.106 7.32518 15.0444 7.22851 14.9472 7.20165C14.7134 7.13676 14.4796 7.072 14.2458 7.00711C14.1486 6.98013 14.0485 7.03194 14.0109 7.12861L13.859 7.51972C13.6622 7.53891 13.4718 7.59264 13.2954 7.67648L12.9743 7.41609C12.8952 7.35181 12.7835 7.35877 12.7123 7.43241C12.5411 7.60955 12.3699 7.78682 12.1988 7.96396C12.1276 8.0376 12.1209 8.15322 12.183 8.23526L12.4344 8.56724C12.3532 8.75135 12.302 8.94924 12.2834 9.15073L11.9052 9.30809C11.8118 9.34695 11.7618 9.45057 11.7878 9.5512C11.8505 9.79323 11.9131 10.0353 11.9757 10.2773C12.0018 10.3779 12.0952 10.4417 12.1947 10.4271L12.5984 10.3676C12.7108 10.5316 12.8497 10.6766 13.0108 10.7951L12.9534 11.2124C12.9392 11.3156 13.0009 11.4123 13.0981 11.4391C13.3321 11.504 13.5659 11.5688 13.7997 11.6337ZM14.2815 8.32041C14.815 8.46842 15.1316 9.03607 14.9887 9.58838C14.8457 10.1407 14.2973 10.4685 13.7638 10.3205C13.2303 10.1725 12.9136 9.60481 13.0566 9.05251C13.1994 8.5002 13.7479 8.17241 14.2815 8.32041Z"
      fill="#767B85"
    />
  </svg>
);

const PngIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path
      d="M15.125 8.5625H8.875C8.35723 8.5625 7.9375 8.98223 7.9375 9.5V14.5C7.9375 15.0178 8.35723 15.4375 8.875 15.4375H15.125C15.6428 15.4375 16.0625 15.0178 16.0625 14.5V9.5C16.0625 8.98223 15.6428 8.5625 15.125 8.5625Z"
      stroke="#907BFF"
      stroke-linejoin="round"
    />
    <path
      d="M13.5625 11.0625C13.9077 11.0625 14.1875 10.7827 14.1875 10.4375C14.1875 10.0923 13.9077 9.8125 13.5625 9.8125C13.2173 9.8125 12.9375 10.0923 12.9375 10.4375C12.9375 10.7827 13.2173 11.0625 13.5625 11.0625Z"
      stroke="#907BFF"
      stroke-miterlimit="10"
    />
    <path
      d="M12.9375 13.5598L11.1668 11.7924C11.0541 11.6797 10.9027 11.6144 10.7434 11.6096C10.5842 11.6049 10.4291 11.6612 10.31 11.767L7.9375 13.8764"
      stroke="#907BFF"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M11.375 15.4389L13.784 13.0299C13.8942 12.9195 14.0416 12.8543 14.1974 12.847C14.3532 12.8398 14.5061 12.8911 14.626 12.9908L16.0625 14.1889"
      stroke="#907BFF"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const PptxIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.07776 16.7452H14.9111C15.3713 16.7452 15.7444 16.3721 15.7444 15.9118V10.0785C15.7444 9.61827 15.3713 9.24518 14.9111 9.24518H10.2561C10.0353 9.24518 9.82356 9.33289 9.66735 9.48893L8.4886 10.6677C8.3322 10.824 8.24443 11.0361 8.24443 11.2573V15.9118C8.24443 16.3721 8.61753 16.7452 9.07776 16.7452Z"
      stroke="#FFA500"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.3278 9.24518V10.9118C10.3278 11.142 10.1412 11.3285 9.9111 11.3285H8.24443"
      stroke="#FFA500"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="10.1195"
      y="13.0992"
      width="1.25"
      height="1.5625"
      stroke="#FFA500"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="11.3689"
      y="11.3285"
      width="1.25"
      height="3.33333"
      stroke="#FFA500"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <rect
      x="12.6192"
      y="12.266"
      width="1.25"
      height="2.39583"
      stroke="#FFA500"
      stroke-width="0.7"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);

const XlsIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8103C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M10.4613 8.42859C9.5871 8.42859 9.2017 8.5056 8.81052 8.7148C8.46224 8.90107 8.18677 9.17654 8.0005 9.52483C7.79129 9.91601 7.71429 10.3014 7.71429 11.1756V12.8244C7.71429 13.6986 7.79129 14.084 8.0005 14.4752C8.18677 14.8235 8.46224 15.099 8.81052 15.2852C9.2017 15.4944 9.5871 15.5714 10.4613 15.5714H13.5387C14.4129 15.5714 14.7983 15.4944 15.1895 15.2852C15.5378 15.099 15.8132 14.8235 15.9995 14.4752C16.2087 14.084 16.2857 13.6986 16.2857 12.8244V11.1756C16.2857 10.3014 16.2087 9.91601 15.9995 9.52483C15.8132 9.17654 15.5378 8.90107 15.1895 8.7148C14.7983 8.5056 14.4129 8.42859 13.5387 8.42859H10.4613ZM9.14738 9.34467C9.38335 9.21847 9.6274 9.14287 10.4613 9.14287H11.6429V10.5714H8.44808C8.47817 10.1968 8.54181 10.0273 8.63037 9.86168C8.75006 9.63787 8.92357 9.46436 9.14738 9.34467ZM11.6429 11.2857H8.42857V12.7143H11.6429V11.2857ZM12.3571 12.7143V11.2857H15.5714V12.7143H12.3571ZM11.6429 13.4286H8.44808C8.47817 13.8032 8.54181 13.9728 8.63037 14.1384C8.75006 14.3622 8.92357 14.5357 9.14738 14.6554C9.38335 14.7816 9.6274 14.8572 10.4613 14.8572H11.6429V13.4286ZM12.3571 14.8572V13.4286H15.5519C15.5218 13.8032 15.4582 13.9728 15.3696 14.1384C15.2499 14.3622 15.0764 14.5357 14.8526 14.6554C14.6166 14.7816 14.3726 14.8572 13.5387 14.8572H12.3571ZM12.3571 10.5714V9.14287H13.5387C14.3726 9.14287 14.6166 9.21847 14.8526 9.34467C15.0764 9.46436 15.2499 9.63787 15.3696 9.86168C15.4582 10.0273 15.5218 10.1968 15.5519 10.5714H12.3571Z"
      fill="#079455"
    />
  </svg>
);

const DocsIcon = ({ width, height }: { width: string; height: string }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5.74179 0.5H14.193L21.1002 7.40723V20.876C21.1 22.2962 19.8607 23.5 18.2643 23.5H5.74179C4.13851 23.4998 2.90023 22.2955 2.89999 20.876V3.12402C2.9002 1.70453 4.13846 0.500196 5.74179 0.5Z"
      fill="white"
      stroke="#DBDBDB"
    />
    <path
      d="M14.4 4.89844V0L21.6 7.2H16.8102C14.6549 7.2 14.4 5.68285 14.4 4.89844Z"
      fill="#D4D4D8"
    />
    <path
      d="M15.125 11.3213V15.125C15.125 15.3736 15.0262 15.6121 14.8504 15.7879C14.6746 15.9637 14.4361 16.0625 14.1875 16.0625H9.8125C9.56386 16.0625 9.3254 15.9637 9.14959 15.7879C8.97377 15.6121 8.875 15.3736 8.875 15.125V8.875C8.875 8.62636 8.97377 8.3879 9.14959 8.21209C9.3254 8.03627 9.56386 7.9375 9.8125 7.9375H11.7412C11.9069 7.93753 12.0658 8.00335 12.183 8.12051L14.942 10.8795C15.0591 10.9967 15.125 11.1556 15.125 11.3213Z"
      stroke="#5563F5"
      stroke-linejoin="round"
    />
    <path
      d="M12 8.09375V10.4375C12 10.6033 12.0658 10.7622 12.1831 10.8794C12.3003 10.9967 12.4592 11.0625 12.625 11.0625H14.9688"
      stroke="#5563F5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.4375 12.625H13.5625"
      stroke="#5563F5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M10.4375 14.1875H13.5625"
      stroke="#5563F5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
  </svg>
);
